import defaultSite from "./content/site.json" with { type: "json" };

type SiteContent = typeof defaultSite;

const absoluteUrl = (value: string, base: string) => new URL(value, base).href;

export function structuredRestaurant(site: SiteContent) {
  const origin = site.seo.url;
  return {
    "@context": "https://schema.org",
    "@type": "Restaurant",
    "@id": `${origin}#asura`,
    name: "Asura Thai",
    url: origin,
    image: absoluteUrl(site.seo.image, origin),
    description: site.seo.description.zh,
    servesCuisine: "Thai",
    sameAs: site.contact.social.map((item) => item.href),
    hasMenu: {
      "@type": "Menu",
      "@id": `${origin}#menu`,
      name: site.menu.title.zh,
      hasMenuItem: site.menu.items.map((item) => ({
        "@type": "MenuItem",
        name: item.name.zh,
        description: item.description.zh,
        image: absoluteUrl(item.image, origin),
      })),
    },
    subOrganization: site.contact.columns.map((column, index) => {
      const directContact = column.href.startsWith("tel:") || column.href.startsWith("https://wa.me/");
      const address = column.lines.slice(directContact ? 1 : 0, -1).map((line) => line.zh).join(" ");
      return {
        "@type": "Restaurant",
        "@id": `${origin}#location-${index + 1}`,
        name: column.title.zh,
        servesCuisine: "Thai",
        address: { "@type": "PostalAddress", streetAddress: address, addressLocality: "香港", addressCountry: "HK" },
        hasMap: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`,
        ...(column.href.startsWith("tel:") ? { telephone: column.href.slice(4) } : {}),
      };
    }),
  };
}

export function serializeStructuredData(site: SiteContent) {
  return JSON.stringify(structuredRestaurant(site)).replaceAll("<", "\\u003c");
}
